<script setup lang="ts">
    import { Info } from 'lucide-vue-next';
    import { HoverCardContent, HoverCardPortal, HoverCardRoot, HoverCardTrigger } from 'reka-ui';
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';

    const props = withDefaults(
        defineProps<{
            openDelay?: number;
            closeDelay?: number;
            content?: string;
            class?: HTMLAttributes['class'];
        }>(),
        {
            openDelay: 0,
            closeDelay: 0,
            class: '',
        },
    );
</script>

<template>
    <HoverCardRoot
        :open-delay="openDelay"
        :close-delay="closeDelay"
    >
        <HoverCardTrigger>
            <slot name="trigger">
                <Info :class="cn('text-secondary/50 size-3.5 shrink-0', props.class)" />
            </slot>
        </HoverCardTrigger>
        <HoverCardPortal>
            <HoverCardContent
                class="animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 w-[300px] rounded-xl border bg-white p-4 shadow-sm data-[state=open]:transition-all"
                :side-offset="5"
            >
                <div class="flex items-center gap-2 text-xs">
                    <slot name="icon">
                        <Info class="text-secondary size-5 shrink-0" />
                    </slot>
                    <slot>{{ content }} </slot>
                </div>
            </HoverCardContent>
        </HoverCardPortal>
    </HoverCardRoot>
</template>
